let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("46WNF")).then(() => parcelRequire('9fiHX'));